import { render, staticRenderFns } from "./writingClass.vue?vue&type=template&id=7be8bf1b&scoped=true"
import script from "./writingClass.vue?vue&type=script&lang=js"
export * from "./writingClass.vue?vue&type=script&lang=js"
import style0 from "./writingClass.vue?vue&type=style&index=0&id=7be8bf1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be8bf1b",
  null
  
)

export default component.exports